import React from 'react';
import MarkdownText from './MarkdownText';

interface ContentTextProps {
  content?: string;
  className?: string;
}

/**
 * Wrapper component for official Daggerheart content with consistent styling
 * Automatically applies content-text CSS classes for proper formatting
 * 
 * Use this component for:
 * - Class descriptions and features
 * - Subclass descriptions (Foundation, Specialization, Mastery)
 * - Ancestry descriptions and abilities
 * - Community descriptions and backgrounds
 * - Domain card descriptions
 * - Equipment special abilities
 */
export const ContentText: React.FC<ContentTextProps> = ({ 
  content, 
  className = '' 
}) => {
  if (!content) {
    return null;
  }

  return (
    <MarkdownText 
      content={content} 
      className={`content-text ${className}`}
    />
  );
};

export default ContentText;